import { Container } from '@mui/material';
import { PageContainer } from '@toolpad/core/PageContainer';
import type React from 'react';
import { useLocation } from 'react-router-dom';
import SharepointWizard from '../components/Sharepoint/SharepointWizard';

const SharepointSetupPage: React.FC = () => {
  const location = useLocation();
  const redirectPath = location.state?.redirectPath;

  return (
    <PageContainer title="">
      <Container maxWidth="md">
        <SharepointWizard redirectPath={redirectPath} />
      </Container>
    </PageContainer>
  );
};

export default SharepointSetupPage;
